"use client";

import { c as _c } from "react/compiler-runtime";
import { IconArrowTrendUpOutline18, IconChartActivityOutline18, IconCircleCheckOutline18, IconClockOutline18, IconRocketOutline18 } from "nucleo-ui-outline-18";
import { useTemplateStats } from "@/hooks/useTemplateStats";
import { formatDuration } from "@/lib/utils";
const RATE_ICON_CLASS = {
  good: "text-emerald-500",
  warn: "text-amber-500",
  bad: "text-red-500"
} as const;
const RATE_TEXT_CLASS = {
  good: "font-semibold text-emerald-600",
  warn: "font-semibold text-amber-600",
  bad: "font-semibold text-red-600"
} as const;
interface TemplateStatsPanelProps {
  templateId: string;
}
export function TemplateStatsPanel(t0) {
  const $ = _c(20);
  const {
    templateId
  } = t0;
  const {
    data: stats,
    isLoading
  } = useTemplateStats(templateId);
  const hasAnyData = stats && (stats.totalDeployments > 0 || stats.activeWorkflows > 0 || stats.recentDeployments > 0);
  if (!isLoading && !hasAnyData) {
    return null;
  }
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <h3 className="body-sm text-ds-text-primary mb-3 font-semibold">Usage Stats:</h3>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="mt-6">{t1}<div className="space-y-2.5">{[1, 2, 3].map(_temp)}</div></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (!stats) {
    return null;
  }
  const rateColor = stats.successRate != null ? stats.successRate >= 90 ? "good" : stats.successRate >= 70 ? "warn" : "bad" : null;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="body-sm text-ds-text-primary mb-3 font-semibold">Usage Stats:</h3>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== stats.totalDeployments) {
    t2 = stats.totalDeployments > 0 && <div className="body-sm text-ds-text-tertiary flex items-center gap-2"><IconRocketOutline18 className="text-ds-text-slate h-4 w-4 shrink-0" /><span><span className="font-semibold">{stats.totalDeployments.toLocaleString()}</span> total deployments</span></div>;
    $[3] = stats.totalDeployments;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== stats.activeWorkflows) {
    t3 = stats.activeWorkflows > 0 && <div className="body-sm text-ds-text-tertiary flex items-center gap-2"><IconChartActivityOutline18 className="text-ds-text-slate h-4 w-4 shrink-0" /><span><span className="font-semibold">{stats.activeWorkflows.toLocaleString()}</span> active workflows</span></div>;
    $[5] = stats.activeWorkflows;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== stats.recentDeployments) {
    t4 = stats.recentDeployments > 0 && <div className="body-sm text-ds-text-tertiary flex items-center gap-2"><IconArrowTrendUpOutline18 className="text-ds-text-slate h-4 w-4 shrink-0" /><span><span className="font-semibold">{stats.recentDeployments.toLocaleString()}</span> recent deployments</span></div>;
    $[7] = stats.recentDeployments;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rateColor || $[10] !== stats.successRate) {
    t5 = rateColor && stats.successRate != null && <div className="body-sm flex items-center gap-2"><IconCircleCheckOutline18 className={`h-4 w-4 shrink-0 ${RATE_ICON_CLASS[rateColor]}`} /><span className={RATE_TEXT_CLASS[rateColor]}>{stats.successRate}% success on recent deploys</span></div>;
    $[9] = rateColor;
    $[10] = stats.successRate;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== stats.avgExecutionTimeMs) {
    t6 = stats.avgExecutionTimeMs != null && <div className="body-sm text-ds-text-tertiary flex items-center gap-2"><IconClockOutline18 className="text-ds-text-slate h-4 w-4 shrink-0" /><span>Avg execution: <span className="font-semibold">{formatDuration(stats.avgExecutionTimeMs)}</span></span></div>;
    $[12] = stats.avgExecutionTimeMs;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className="mt-6">{t1}<div className="space-y-3">{t2}{t3}{t4}{t5}{t6}</div></div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp(i) {
  return <div key={i} className="bg-ds-neutral-250 h-5 w-3/4 animate-pulse rounded" />;
}